import React from 'react';
import { Grid } from '@mui/material';
import { makeStyles } from '@material-ui/core';



const useStyles = makeStyles((theme) => ({
	formGroup: {
		[theme.breakpoints.up('sm')]: {
			minWidth: '30rem',
		},
		'& .custom-label': {
			marginBottom: theme.spacing(.625),

		},
		'& .form-indent': {
			marginLeft: theme.spacing(1.25),
		},
		'& .custom-sublabel': {
			marginTop: theme.spacing(.625),
			marginBottom: theme.spacing(2),
			[theme.breakpoints.down('md')]: {
				marginBottom: theme.spacing(1.5),
			},
			[theme.breakpoints.down('sm')]: {
				marginBottom: theme.spacing(1),
			},
		},
		'& .form-item': {
			'& textarea': {
				'&.MuiInputBase-inputMultiline': {
					resize: 'auto',

				},
			},
			'& + .form-item, & + .form-indent': {
				marginTop: theme.spacing(2),
				[theme.breakpoints.down('md')]: {
					marginTop: theme.spacing(1.5),
				},
				[theme.breakpoints.down('sm')]: {
					marginTop: theme.spacing(1),
				},
			},
		},
	},
}));


interface Props {
	indent?: boolean,
}
export const FormGroup = (props: React.PropsWithChildren<Props>) => {
	const classes = useStyles();
	return (
		<>
			<Grid className={props.indent ? 'form-indent' : ''} container item xs={12} sm={9} lg={6} >
				<Grid item xs={12} className={`${classes.formGroup} ${props.indent ? 'form-indent' : ''}`}>
					{props.children}
				</Grid>
			</Grid>
		</>
	);
};

FormGroup.defaultProps = {
	indent: false,
};